import React, { useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import MobileMenuPane from './MobileMenuPane';
import { Container } from 'semantic-ui-react';
import Portal from './Portal';
import { flatListToHierarchical } from '../../../helpers/menus';

export default function MobileMenu() {
  const [activePane, setActivePane] = useState(null);
  const setInactivePane = () => setActivePane(null);
  const data = useStaticQuery(graphql`
    query mobileMenu {
      wpMenu(slug: { eq: "mobile-menu" }) {
        menuItems {
          nodes {
            cssClasses
            url
            target
            label
            id
            parentId
            menuAcf {
              menuIcon {
                sourceUrl
              }
            }
          }
        }
      }
    }
  `);
  const menuItems = data.wpMenu.menuItems.nodes;
  const formattedMenuItems = flatListToHierarchical(menuItems);

  return (
    <div className="mobile-nav">
      <Container className="mobile-nav__container">
        <nav className="mobile-nav__top-level">
          <div className="mobile-nav__pane-wrapper">
            {formattedMenuItems.map((item, i) => {
              return (
                <MobileMenuPane
                  key={i}
                  activePane={activePane}
                  setActivePane={setActivePane}
                  setInactivePane={setInactivePane}
                  label={item.label}
                  url={item.url}
                  index={i}
                  classes={item.cssClasses}
                  childItems={item.childItems}
                  menuAcf={item.menuAcf}
                />
              );
            })}
          </div>
        </nav>
      </Container>
      <Portal />
    </div>
  );
}
